const { displayMessage } = require("../services/helper");

module.exports = {
    MONITOR: { description: displayMessage('MONITOR'), code: 1 },
    ADMIN: { description: displayMessage('ADMINISTRATOR'), code: 2 },
    DENTIST: { description: displayMessage('DENTIST'), code: 3 },
    INTERNAL: [1, 2, 3] // ARRAY COM TODOS OS TIPOS DE USUÁRIO (SEM PACIENTE)
}